import { useCallback, useEffect, useRef, useState } from "react"
import { getFacilitator } from "../../services/communityService";
import { ApiArrayResponseModel } from "./models/ApiResponseModel";
import { FacilitatorModel } from "./models/FacilitatorModel";

export const useFacilitators = () => {
    const isMountedRef = useRef(true);
    const [list, setList] = useState<FacilitatorModel[]>([]);

    useEffect(() => {
        isMountedRef.current = true;
        return () => {
            isMountedRef.current = false;
        }
    }, []);
    
    const load = useCallback(async () => {
        try {
            const _data: ApiArrayResponseModel<FacilitatorModel> = await getFacilitator();
            if(!isMountedRef.current)
                return;
            setList(_data.results);
        }
        catch {

        }
    }, []);

    useEffect(() => {
        load();
    }, [load]);

    return { list }
}